import Service from "../Service";
const resource = "HmnEducationalLevel/";

export default {

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },
    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    list(requestID) {
        return Service.post(resource + "list", { } , {
            params: { requestID: requestID },
        });
    },

};